import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "@/lib/api";
import { useAuth } from "@/auth/AuthProvider";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    // Preserve the path the user was on so post-OAuth flows (e.g. publish-after-signin) can resume.
    const returnPath = window.location.pathname || "/dashboard";

    (async () => {
      if (!sessionId) {
        nav("/login", { replace: true });
        return;
      }
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error("session exchange failed");
        const data = await res.json();
        await refresh();
        // Clean up the hash and return to the path the user came from
        window.history.replaceState({}, "", returnPath);
        nav(returnPath, { replace: true, state: { user: data.user } });
      } catch {
        nav("/login", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-[60vh] grid place-items-center">
      <div className="flex items-center gap-3 text-slate-600">
        <Loader2 className="animate-spin" size={18} />
        <span>Finishing sign-in…</span>
      </div>
    </div>
  );
}
